import * as PropTypes from 'prop-types';
import React, { useState } from 'react';
import TextField from '../../../../../components/TextField';
import { connect } from 'react-redux';
import {
    fetchChannelAvailability,
    setChannelUserName,
    setChannelUserNameStatus,
} from '../../../../../actions/channels';
import { showMessage } from '../../../../../actions/snackbar';
import { CircularProgress, InputAdornment } from '@mui/material';
import verifiedIcon from '../../../../../assets/account/verified.svg';

const UserNameTextField = (props) => {
    const [time, setTime] = useState(null);
    const onChange = (value) => {
        const validation = value && value.split(' ');
        if (validation && validation.length && validation.length > 1) {
            props.showMessage('Spaces is not allowed in Username');
            return;
        }

        props.onChange(value);
        if (time) {
            clearInterval(time);
        }
        const interval = setTimeout(() => {
            props.fetchChannelAvailability(value, (cb, error) => {
                if (cb && cb.available) {
                    props.setChannelUserNameStatus(false);
                } else {
                    props.setChannelUserNameStatus(true);
                    props.showMessage(error || 'Channel Already Exist');
                }
            });
        }, 1000);
        setTime(interval);
    };

    return (
        <TextField
            id="channelUserName"
            inputProps={{
                endAdornment: (
                    <InputAdornment
                        position="end">
                        <div>
                            {props.inProgress
                                ? <CircularProgress/>
                                : !props.status
                                    ? <img alt="verified" height="23" src={verifiedIcon} width="23"/>
                                    : null}
                        </div>
                    </InputAdornment>
                ),
            }}
            name="channelUserName"
            placeholder="Enter Username"
            value={props.value}
            variant="outlined"
            onChange={onChange}/>
    );
};

UserNameTextField.propTypes = {
    fetchChannelAvailability: PropTypes.func.isRequired,
    inProgress: PropTypes.bool.isRequired,
    lang: PropTypes.string.isRequired,
    setChannelUserNameStatus: PropTypes.func.isRequired,
    showMessage: PropTypes.func.isRequired,
    status: PropTypes.bool.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

const stateToProps = (state) => {
    return {
        lang: state.language,
        value: state.channels.userName,

        inProgress: state.channels.channelAvailability.inProgress,
        status: state.channels.usernameStatus,
    };
};

const actionToProps = {
    onChange: setChannelUserName,
    fetchChannelAvailability,
    showMessage,
    setChannelUserNameStatus,
};

export default connect(stateToProps, actionToProps)(UserNameTextField);
